import React from 'react';

import styles from './Background.module.scss';

export default function Background({ featured = false, ...props }) {
  return (
    <>
      <div className={styles.backgroundWrap}>
        <div className={styles.background} />
        {featured && <div className={styles.featured} />}
      </div>

      <div className={styles.contentWrap} {...props} />
    </>
  );
}
